import * as React from 'react';
import { useState, useEffect } from 'react';

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';

import { handleFileUpload } from '../Helper/FIleUploaderToS3';
import { BackdropLoader } from '../BackdropLoader';
import { validateFileSizeLimit } from '../Helper/utils';
import { ToastEmitter } from '../ToastEmitter';
import { VisuallyHiddenInput } from '../StyledComponent';
import { EXCEED_SIZE_LIMIT } from '../constant';

export const UploadDoctorProfilePhoto = ({ getValues, setValue, name }) => {
  const profilePhotoUrl = getValues(name);
  const [selectedImage, setSelectedImage] = useState(profilePhotoUrl);
  const [isLoading, setIsLoading] = useState(false);
  const renderSelectedFiles = async (file) => {
    try {
      setIsLoading(true);
      const uploadedFile = await handleFileUpload(file, 'profile-image');
      setValue(name, uploadedFile, { shouldValidate: true, shouldDirty: true })
      setSelectedImage(uploadedFile);
    }
    catch (err) {
      ToastEmitter(err.message, 'error');
    }
    finally {
      setIsLoading(false);
    }
  }

  const fileSelectedHandler = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateFileSizeLimit(file, 2)) {
        ToastEmitter(EXCEED_SIZE_LIMIT, "error");
        return;
      }
      renderSelectedFiles([file])
    }
  };

  const handleDelete = (index) => {
    setSelectedImage();
    setValue(name, '', { shouldValidate: true })

  };
  return (
    <>
      <div className="flex flex-row gap-2 p-2 " style={{ width: 'fit-content', height: 'fit-content' }}>
        {isLoading && <BackdropLoader isLoading={isLoading} />}
        {(!profilePhotoUrl) && <Button
          className='border-[#70829B] bg-white  border-2 w-[80px] h-[80px] rounded-full flex flex-col justify-center items-center fit-content'
          component="label"
          style={{ width: '8.5rem', height: '8.5rem' }}
          variant=""
        >
          <img src="https://views.medibuddy.in/providerUi/assets/DoctorUpload.svg" alt="" className="flex justify-enter" />
          <p className="text-sm font-normal text-[#70829B]" style={{ textAlign: 'center', textTransform: 'none' }}> Upload Doctor Photo</p>

          <VisuallyHiddenInput
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            onChange={(event) => (fileSelectedHandler(event))}
          />
        </Button>
        }
        {profilePhotoUrl && <div className='flex flex-row gap-2 ' style={{ height: '120px' }} >
          <img src={profilePhotoUrl} alt="" height={152} width={152} />
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(); }}
            className="absolute top-0 right-0  text-white bg-red-500 rounded-full p-1"
          >
            <DeleteIcon />
          </button>
        </div>}
      </div>
    </>

  );
}
